import type { SVGProps } from "react";
const SvgIconUser = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <circle cx={512} cy={352} r={160} />
    <path d="M384 562h256a192 192 0 0 1 192 192v28a50 50 0 0 1-50 50H242a50 50 0 0 1-50-50v-28a192 192 0 0 1 192-192" />
  </svg>
);
export default SvgIconUser;
